import { Component, OnDestroy, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

import { SegmentedNavigationItemModel } from '../../components/segmented-navigation/components/segmented-navigation-item/segmented-navigation-item.model';
import { SegmentedNavigationComponent } from '../../components/segmented-navigation/segmented-navigation.component';
import { AccountFacade, AccountViewModel } from './account.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  providers: [AccountFacade],
})
export class AccountComponent implements OnDestroy {
  @ViewChild('tabs')
  private tabs: SegmentedNavigationComponent;
  private routerEventsSubscription: Subscription;
  segmentedItems: SegmentedNavigationItemModel[] = [
    new SegmentedNavigationItemModel('informations', 'Informations'),
    new SegmentedNavigationItemModel('password', 'Mot de passe'),
    new SegmentedNavigationItemModel(
      'subscription',
      'Abonnement & Factures',
      undefined,
      undefined,
      undefined,
      true,
    ),
    new SegmentedNavigationItemModel(
      'msdpLink',
      'MonSuiviDiet Plus',
      undefined,
      undefined,
      undefined,
      true,
    ),
    new SegmentedNavigationItemModel(
      'billParams',
      'Paramètres Facturation',
      undefined,
      undefined,
      undefined,
      true,
    ),
  ];
  accountStatus$: Observable<AccountViewModel>;
  private navigationSubscription: Subscription;

  constructor(private facade: AccountFacade, private router: Router) {
    this.accountStatus$ = this.facade.accountStatus$;
    this.navigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/dashboard/account') {
          this.segmentedItems.forEach((item) => {
            item.isActive = item.id === 'informations';
          });
          if (this.tabs) {
            this.tabs.setActiveItem();
          }
        } else {
          const arr = event.url.split('/');
          for (const item of this.segmentedItems) {
            item.isActive = item.id === arr[3] ? true : false;
          }
          if (this.tabs) {
            this.tabs.setActiveItem();
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.navigationSubscription?.unsubscribe();
  }
}
